module.exports = __webpack_public_path__ + "static/media/default-notch.54773810.svg";